<template>
  <div class="way-container">
    <div class="left">
      <ul class="menu-container">
        <li class="menu-item" :class="{active:active === index}" v-for="(item,index) in routerList" :key="index" @click="changeCountry(index,item.path)">
          {{item.country}}
        </li>
      </ul>
    </div>
    <div class="right">
        <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  name: "trackWay",
  data() {
    return {
      active:0,
    }
  },
  computed:{
    routerList(){
      return [
        {id:0,country:this.$t('track.trackWay.russia.routerName'),path:'/track/russia'},
        {id:2,country:this.$t('track.trackWay.uzbekistan.routerName'),path:'/track/Uzbekistan'},
        {id:3,country:this.$t('track.trackWay.kazakhstan.routerName'),path:'/track/kazakhstan'},
        {id:4,country:this.$t('track.trackWay.ukraine.routerName'),path:'/track/UKraine'},
        {id:5,country:this.$t('track.trackWay.belarus.routerName'),path:'/track/belarus'},
        {id:6,country:this.$t('track.trackWay.mongolia.routerName'),path:'/track/mongolia'}
      ]
    }
  },
  methods:{
    changeCountry(index,path){
      this.active = index
      this.$router.push(path)
    }
  }
};
</script>

<style lang="less" scoped>
.way-container {
  padding: 48px 0 48px 48px;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  background-color: #40404a;
  .left {
    .menu-container {
      margin: 0;
      padding: 0;
      width: 400px;
      list-style: none;
      .menu-item {
        box-sizing: border-box;
        width: 100%;
        padding: 24px 48px;
        font-size: 18px;
        font-weight: bold;
        // color: #40404a;
        background-color: #fff;
        cursor: pointer;
        transition: all 0.3s;
        border-bottom: 1px solid #ff5d1b;

        &.active {
          color: #fff;
          background: #ff5d1b;
        }
      }
    }
  }
}
</style>